import { Box, Col, Row } from '@opendoor/atoms/box';
import { Combobox } from '@opendoor/atoms/combobox';
import { Text } from '@opendoor/atoms/text';

import { buildRangeFilterOptions } from './utils';

const RoomSizeOptions = [
  { label: '1+', value: '1' },
  { label: '2+', value: '2' },
  { label: '3+', value: '3' },
  { label: '4+', value: '4' },
];

const BEDS_PLACEHOLDER = { label: 'Min beds', value: '0' };
const BATHS_PLACEHOLDER = { label: 'Min baths', value: '0' };

export interface BedroomsBathroomsFilterProps {
  minBaths?: string | null;
  minBeds?: string | null;
  handleMinBathsChange: (value: string) => void;
  handleMinBedsChange: (value: string) => void;
}

export const BedroomsBathroomsFilter = ({
  minBaths,
  minBeds,
  handleMinBathsChange,
  handleMinBedsChange,
}: BedroomsBathroomsFilterProps) => {
  const bedsOptions = buildRangeFilterOptions(RoomSizeOptions, BEDS_PLACEHOLDER);
  const bathsOptions = buildRangeFilterOptions(RoomSizeOptions, BATHS_PLACEHOLDER);

  return (
    <Col className="w-full gap-6">
      <Text as="p" className="text-label-xl">
        Beds/Baths
      </Text>
      <Row className="w-full items-center justify-between">
        <Text as="p" className="text-body-md">
          Beds
        </Text>
        <Box className="w-[30%] max-md:w-[40%] lg:min-w-34">
          <Combobox
            aria-label="Minimum bedrooms"
            placeholder={BEDS_PLACEHOLDER.label}
            options={bedsOptions}
            value={bedsOptions.find((option) => option.value === minBeds) ?? null}
            size="sm"
            onValueChange={(option) => handleMinBedsChange(option?.value ?? BEDS_PLACEHOLDER.value)}
          />
        </Box>
      </Row>
      <Row className="w-full items-center justify-between">
        <Text as="p" className="text-body-md">
          Baths
        </Text>
        <Box className="w-[30%] max-md:w-[40%] lg:min-w-34">
          <Combobox
            aria-label="Minimum bathrooms"
            placeholder={BATHS_PLACEHOLDER.label}
            options={bathsOptions}
            value={bathsOptions.find((option) => option.value === minBaths) ?? null}
            size="sm"
            onValueChange={(option) =>
              handleMinBathsChange(option?.value ?? BATHS_PLACEHOLDER.value)
            }
          />
        </Box>
      </Row>
    </Col>
  );
};
